import { gql } from '@apollo/client';

export const GET_EVENTS = gql`
  query FetchEvents {
    events {
      name
      link
      location
      startTime
      endTime
      description
      category
      eventParticipants {
        userId
      }
    }
  }
`;
